import { User } from '@admin/customers/shared/models/customer-moderation.model';
import { Serializable } from '../../../core/models/serializable';

export class PortfolioAccountManagerAdminModel
  implements Serializable<PortfolioAccountManagerAdminModel>
{
  fromObject(object: any): PortfolioAccountManagerAdminModel {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public adminId: number;
  public fullName: string;
  public user: User;
}
